<div class="row">
  <div mat-dialog-title class="col-12">Check coverage</div>
  <div class="col-12 mx-0">
    <p><strong>Address:</strong> {{ data.response.p1_label }}</p>
    <p>
      <strong>Coordinates:</strong>
      {{ data.response.p1_coordinate.coordinates[1] }},
      {{ data.response.p1_coordinate.coordinates[0] }}
    </p>
    <p *ngIf="data.response.p1_civico?.id_building">
      <strong>ID Building:</strong> {{ data.response.p1_civico?.id_building }}
    </p>
    <p *ngIf="data.response.riferimento">
      <strong>ID Building:</strong> #{{ data.response.riferimento }}
    </p>
    <p *ngIf="data.response.m1_distance">
      <strong>Distance:</strong> {{ data.response.m1_distance }}
    </p>
    <p *ngIf="data.response.afference_pop_p1">
      <strong>Afference POP:</strong> {{ data.response.afference_pop_p1 }}
    </p>

    <p *ngIf="data.response.stato_building">
      <strong>Building state:</strong> {{ data.response.stato_building }}
    </p>
    <p *ngIf="data.response.p1_civico_type">
      <strong>Technical state:</strong> {{ data.response.p1_civico_type }}
    </p>
    <p *ngIf="data.response.stato_commerciale">
      <strong>Commercial state:</strong> {{ data.response.stato_commerciale }}
    </p>

    <p *ngIf="data.response.fattibile" class="response-icon">
      <i class="far fa-thumbs-up d-block"></i>
      You are connected!
    </p>
    <p *ngIf="data.response.fattibile === false" class="response-icon">
      <i class="far fa-thumbs-down d-block"></i>
      You are not connected!
    </p>
    <div mat-dialog-actions class="mt-2 d-flex justify-content-center">
      <button mat-stroked-button (click)="onNoClick()">Close</button>
    </div>
  </div>
</div>
